module.exports = __webpack_public_path__ + "img/008-wind-6.0b9c0348.svg";